export function useWidget(modern) {
  let scriptUrl = `${process.env.VUE_APP_WIDGET_LEGACY_LOCATION}/dist/at-widget-booking.umd.min.js`
  let cssUrl = `${process.env.VUE_APP_WIDGET_LEGACY_LOCATION}/dist/at-widget-booking.css`

  if (modern) {
    scriptUrl = `${process.env.VUE_APP_WIDGET_LOCATION}/dist-internal/at-widget-booking.umd.min.js`
    cssUrl = `${process.env.VUE_APP_WIDGET_LOCATION}/dist-internal/style.css`
  }

  function component() {
    return window.AtWidgetBooking?.Component
  }

  return new Promise((resolve) => {
    if (component()) {
      return resolve(component())
    }

    const script = document.createElement('script')
    script.onload = () => resolve(component())
    script.setAttribute('src', scriptUrl)
    script.setAttribute('widget-loader', '')
    document.head.appendChild(script)

    const link = document.createElement('link')
    link.setAttribute('href', cssUrl)
    link.setAttribute('type', 'text/css')
    link.setAttribute('rel', 'stylesheet')
    link.setAttribute('widget-loader', '')
    document.head.appendChild(link)
  })
}

export function legacyWidget() {
  return useWidget(false)
}

export function useModernWidget() {
  return useWidget(true).then((widget) => {
    return [
      widget,
      () => {
        // Skip full teardown on HMR: custom elements can only be registered once.
        // If we remove the script and clear AtWidgetBooking, the next load will fail
        // because the script will try to re-register the already-registered element.
        const isHmr = typeof module !== 'undefined' && module.hot
        if (isHmr) {
          return
        }

        window.AtWidgetBooking?.Component?.unmount()
        window.AtWidgetBooking = undefined
        document
          .querySelectorAll('[widget-loader]')
          .forEach((el) => el.remove())
      },
    ]
  })
}
